import React, { Fragment } from "react";
import HeaderWeb from "./HeaderWeb";
import AccountLayoutWeb from "./AccountLayoutWeb";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../../context/AuthContext";

const AccountWeb = () => {
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  return (
    <AccountLayoutWeb>
      <div className="col-center report">
        <h2>Account Details</h2>
        <div className="event-left">
          <div className="profile-wrap">
            <h3>About You</h3>
            <dl>
              <dt>First Name</dt>
              <dd></dd>
              <dt>Last Name</dt>
              <dd>{user?.user?.username}</dd>
              <dt>Birthday</dt>
              <dd>--</dd>
            </dl>
          </div>
          <div className="profile-wrap">
            <h3>Address</h3>
            <dl>
              <dt>Address</dt>
              <dd>--</dd>
              <dt>Town/City</dt>
              <dd>--</dd>
              <dt>Country</dt>
              <dd>--</dd>
              <dt>Country/State</dt>
              <dd>--</dd>
              <dt>Postcode</dt>
              <dd>--</dd>
              <dt>Timezone</dt>
              <dd>IST</dd>
            </dl>
          </div>
        </div>
        {/* <div className="event-right">
          <div className="profile-wrap">
            <h3>Setting</h3>
            <dl>
              <dt>Currency</dt>
              <dd>USD</dd>
              <dt>Odds Format</dt>
              <dd>--</dd>
            </dl>
          </div>
          <div className="profile-wrap">
            <h3>Commission</h3>
            <dl>
              <dt>Comm charged</dt>
              <dd>2.00 %</dd>
            </dl>
          </div>
        </div> */}
      </div>
    </AccountLayoutWeb>
  );
};

export default AccountWeb;
